export const xmCloudProduct = {
  name: 'XM Cloud',
  displayName: {
    source: {
      jsonPath: '$.displayName',
      resource: 'tenant',
    },
  },
  description:
    'Sitecore XM Cloud is a modern, agile, cloud-native and Jamstack-ready CMS that supports the creation and delivery of engaging omnichannel experiences powered by content.',
  baseUrl: {
    dev: 'https://xmapps-staging.sitecore-staging.cloud',
    qa: 'https://xmapps-staging.sitecore-staging.cloud',
    staging: 'https://xmapps-staging.sitecore-staging.cloud',
    'pre-production': 'https://xmapps-preprod.sitecorecloud.io',
    preprod: 'https://xmapps-preprod.sitecorecloud.io',
    production: 'https://xmapps.sitecorecloud.io',
  },
  link: {
    type: 'external-link',
    to: '{baseUrl}?tenantName={tenantName}&organization={organizationId}',
    replacements: [
      {
        key: 'baseUrl',
        source: {
          jsonPath: "$.baseUrl['#env#']",
          resource: '_self',
        },
      },
      {
        key: 'tenantName',
        source: {
          resource: 'tenant',
          jsonPath: '$.name',
        },
      },
      {
        key: 'organizationId',
        source: {
          resource: 'tenant',
          jsonPath: '$.organizationId',
        },
      },
    ],
  },
  icon: {
    type: 'url',
    src: 'https://mss-p-006-delivery.stylelabs.cloud/api/public/content/740b04f7a7ca404e96d69319fb98f6b0?v=72b6708c',
  },
  color: 'teal',
  openInTab: true,
};
